module.exports = __webpack_public_path__ + "5b206176d519be738dc63f87c2b9934b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-68@2x.png
// module id = 531
// module chunks = 0